import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Dr. Thomas Schwenk',
  role: 'Inhaber / Ästhetik & Funktion',
  offset: 'mt-0'
}, {
  name: 'Dr. Markus Striegel',
  role: 'Inhaber / Ästhetik & Funktion',
  offset: 'mt-16 md:mt-32'
}, {
  name: 'Dr. Johanna Herzog M.Sc.',
  role: 'Inhaberin / Kieferorthopädie',
  offset: 'mt-8 md:mt-16'
}];
export function TeamSection() {
  return <section className="py-32 bg-weiss" data-id="element-191">
      <div className="max-w-7xl mx-auto px-6" data-id="element-192">
        <div className="mb-20 max-w-2xl" data-id="element-193">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading text-schwarz mb-6" data-id="element-194">
            Unser Team
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-warm-gray font-body" data-id="element-195">
            Ihre Zahnärztinnen und Zahnärzte in Nürnberg, Fürth und Erlangen.
            Bei uns arbeiten ausnahmslos Experten, die in ihrem jeweiligen
            Fachgebiet über herausragende Expertise verfügen.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-196">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className={`group cursor-pointer ${member.offset}`} data-id="element-197">
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] mb-6 bg-gradient-to-br from-sand to-beige" data-id="element-198">
                {/* Placeholder for image */}
                <div className="absolute inset-0 bg-royal-blue/5 group-hover:bg-royal-blue/0 transition-colors duration-500" data-id="element-199" />
                <motion.div className="absolute inset-0 bg-gradient-to-t from-schwarz/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-8" data-id="element-200">
                  <p className="text-weiss text-sm font-body translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-201">
                    Spezialisiert auf zukunftsweisende Zahnmedizin und
                    individuelle Betreuung auf höchstem Niveau.
                  </p>
                </motion.div>
              </div>
              <h3 className="text-2xl font-heading text-schwarz mb-1" data-id="element-202">
                {member.name}
              </h3>
              <p className="text-royal-blue text-sm font-body font-medium" data-id="element-203">
                {member.role}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}